import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "../hooks/useSettings";
import { PAGE_SEO, SERVICE_SEO, SITE } from "../data/seo";

const setMeta = (sel, attr, val) => {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement(sel.startsWith("link") ? "link" : "meta");
    const m = sel.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/);
    el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, val || "");
};

const setLd = (id, data) => {
  let el = document.getElementById(id);
  if (!data) { if (el) el.remove(); return; }
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
  el.textContent = JSON.stringify(data);
};

export function defaultsFor(pathname) {
  const svc = pathname.match(/^\/services\/([^/]+)/);
  return (svc ? SERVICE_SEO[svc[1]] : PAGE_SEO[pathname]) || {};
}

export function Seo({ title, description, type = "website", jsonLd, breadcrumbs }) {
  const { pathname } = useLocation();
  const settings = useSettings();
  useEffect(() => {
    const d = defaultsFor(pathname);
    const o = settings?.seo?.[pathname] || {};
    const t = o.title || d.title || title;
    const desc = o.description || d.description || description;
    const kw = o.keywords || d.keywords || "";
    const origin = window.location.origin;
    document.title = t ? `${t} | ${SITE}` : `${SITE} | Evidence. Insights. Access.`;
    setMeta('meta[name="description"]', "content", desc);
    if (kw) setMeta('meta[name="keywords"]', "content", kw);
    setMeta('meta[property="og:title"]', "content", document.title);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[property="og:url"]', "content", origin + pathname);
    setMeta('meta[property="og:image"]', "content", "https://marksmanhealthcare.com/og-image.png");
    setMeta('meta[name="twitter:image"]', "content", "https://marksmanhealthcare.com/og-image.png");
    setMeta('meta[name="twitter:title"]', "content", document.title);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('link[rel="canonical"]', "href", origin + pathname);
    setLd("ld-json", jsonLd);
    const crumbs = breadcrumbs || (pathname !== "/" ? [{ name: "Home", path: "/" }, { name: t, path: pathname }] : null);
    setLd("ld-breadcrumbs", crumbs && { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: origin + c.path })) });
  }, [title, description, type, jsonLd, breadcrumbs, pathname, settings]);
  return null;
}
